import { Checkbox as FlowbiteCheckbox } from "flowbite-react";
export default FlowbiteCheckbox;
